const state = {
  items: [],
}

const getters = {
  count: state => {
    return state.items.length;
  },
  getById: (state) => (id) => {
    return state.items.find(item => item.id == id);
  },
  getAll: (state) => {
    return state.items;
  },
  getByEmail: (state) => (email) => {
    return state.items.find(item => item.email == email);
  },
  getPersonasByEquipoTorneo: (state) => (equipo, id_torneo) => {
    return state.items.filter(item => item.equipo == equipo && item.id_torneo == id_torneo);
  },
  planilleros: state => {
    return state.items.filter(persona => persona.tipo == 'planillero').sort((a, b) => a.apellido.localeCompare(b.apellido));
  },
  planillerosCombo: (state, getters) => {
    return getters.planilleros.map(planillero => ({value: planillero.id, text: `${planillero.apellido}, ${planillero.nombre}`}));
  },
  arbitros: state => {
    return state.items.filter(persona => persona.tipo == 'arbitro').sort((a, b) => a.apellido.localeCompare(b.apellido));
  },
  arbitrosCombo: (state, getters) => {
    return getters.arbitros.map(arbitro => ({value: arbitro.id, text: `${arbitro.apellido}, ${arbitro.nombre}`}))
  },
  coordinadores: state => {
    return state.items.filter(persona => persona.tipo == 'coordinador').sort((a, b) => a.apellido.localeCompare(b.apellido));
  },
  coordinadoresCombo: (state, getters) => {
    return getters.coordinadores.map(coordinador => ({value: coordinador.id, text: `${coordinador.apellido}, ${coordinador.nombre}`}))
  }
}

const actions = {

  retrieveFromLS ({ commit }) {
    let items = JSON.parse(localStorage.getItem('db.personas'));
    if (items) commit('setItems', items);
  },

  setAndPersistLS({ dispatch, commit }, items) {
    commit('setItems', items);
    dispatch('persistLS');
  },

  persistLS({ state }) {
    localStorage.setItem('db.personas', JSON.stringify(state.items));
  }
}

const mutations = {
  setItems (state, items) {
    state.items = items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}